<template>
	<div class="ak2 ak">
		<div class="banner" id="banner2"><div class="banner-pro"></div></div>
		<div class="page-main-content">
			<div class="section2 section2-ak2">
				<p class="text">{{text.second.text}}</p>
				<i class="airicon"></i>
			</div>
			<div class="section3">
				<img
					class="s3mobile-bg hidden"
					src="../assets/image/ak/easyset-mobile.jpg"
					alt=""
				/>
				<div class="desc-text easyplan">
					<h3 class="title">{{text.third[0].title}}</h3>
					<p class="text">{{text.third[0].text}}</p>
				</div>
				<div class="desc-text autonomous">
					<h3 class="title">{{text.third[1].title}}</h3>
					<p class="text">{{text.third[1].text}}</p>
				</div>
				<div class="redline rline">
					<div class="whiteline wline">
						<div class="dattedline dline"></div>
					</div>
				</div>
				<img
					class="redline-mobile rline hidden"
					src="../assets/image/ak/redline-mobile.png"
					alt=""
				/><i class="whiteline-mobile wline hidden"></i
				><img
					v-if="$route.params.lang==='EN'"
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile-en.png"
					alt=""
				/>
				<img
					v-else
					class="dline dattedline-mobile hidden"
					src="../assets/image/ak/airline-mobile.png"
					alt=""
				/><img class="airplane" src="../assets/image/ak/airplane.png" alt="" />
			</div>
			<div class="section section4 section4-ak2">
				<img
					class="section4bg-mobile hidden"
					src="../assets/image/ak/ak2yth-designbg.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.forth.title}}</h3>
					<p class="text">{{text.forth.text}}</p>
				</div>
			</div>
			<div class="section section5">
				<img
					v-if="$route.params.lang === 'EN'"
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile-en.png"
					alt=""
				/>
				<img
					v-else
					class="section5bg-mobile hidden"
					src="../assets/image/ak/security-stability-mobile.jpg"
					alt=""
				/>
				<div class="section-text">
					<h3 class="title">{{text.fifth.title}}</h3>
					<p class="text">{{text.fifth.text}}</p>
				</div>
			</div>
			<div class="section section6">
				<div class="section-text">
					<h3 class="title">{{text.sixth.title}}</h3>
					<p class="text">{{text.sixth.text}}</p>
				</div>
				<div class="interface">
					<i class="arrow1"></i>
					<p class="arrow1-text">{{text.sixth.tips[0]}}</p>
					<i class="arrow2"> </i
					><img
						v-if="$route.params.lang==='EN'"
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile-en.png"
						alt=""
					/><img
						v-else
						class="interface-mobile hidden"
						src="../assets/image/ak/interface-mobile.png"
						alt=""
					/>
					<p class="arrow2-text">{{text.sixth.tips[1]}}</p>
				</div>
			</div>
			<div class="section7">
				<h3 class="title">{{text.paramsTitle}}</h3>
				<div class="detaild-table ak-table ak2-table">
					<div v-for="(item, i) in text.params" :key="i">
						<p class="its-title">{{item.title}}</p>
						<ul>
							<li v-for="(c, index) in item.children" :key="index">
								<dl class="its-dl">
									<dt class="its-dt">{{c.title}}</dt>
									<dd class="its-dd">
										<ul>
											<li v-for="(cc, k) in c.children" :key="k" :class="{'its-twoli': cc.length !== 1}" >
												<div>
													<p>{{cc[0].name}}</p>
													<span :class="{'null': !cc[0].value}">{{cc[0].value}}</span>
												</div>
												<div>
													<p>{{cc[1] && cc[1].name}}</p>
													<span :class="{'null': !cc[1] || !cc[1].value}">{{cc[1] && cc[1].value}}</span>
												</div>
											</li>
										</ul>
									</dd>
								</dl>
							</li>
						</ul>
					</div>
					<!-- <p class="its-title">性能参数</p>
					<ul class="its-table">
						<li>
							<dl class="its-dl">
								<dt class="its-dt"></dt>
								<dd class="its-dd">
									<ul>
										<li class="its-twoli">
											<div>
												<p>AK2增强版</p>
												<span class="null"></span>
											</div>
											<div>
												<p>AK2</p>
												<span class="null"></span>
											</div>
										</li>
									</ul>
								</dd>
							</dl>
						</li>
						<li>
	-->
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>
<script>
import { init } from "@/js/ak.js";
import { AK2 } from '@/js/text.js';
import { mapState, mapMutations } from 'vuex'

export default {
	name: 'ak2',
	metaInfo: {
		meta: [{
			name: 'keywords', 
			content: '固定翼,飞控,PowerPC,传感器,电力,测绘,农林,侦察,巡检,自主飞行,自动降落,航线飞行,GPS,气压传感器'
		},{
			name: 'description', 
			content: 'AK2是一款针对油动、中远程固定翼无人机打造的高可靠性、高性能、低成本飞控。AK2内置姿态、磁航向、静压、空速传感器、GPS接收机以及数传电台，高集成度设计保证了系统的可靠性。AK2采用PowerPC 处理器，运行实时操作系统，确保了软件安全、可靠的运行，并具有较高的抗干扰能力。AK2已经过军方数百架次严格的飞行考核，现已广泛用于测绘、侦查、农林监护、电力、环境监测等领域。'
		}]
	},
	data() {
		return{}
	},
	components: {
		Foot: () => import("@/components/footer.vue"),
	},
	computed: {
		...mapState(['headerStyle']),
		text() {
			return this.$route.params.lang === 'CN' ? AK2.CN : AK2.EN
		}
	},
	methods: {
		...mapMutations(['setHeaderStyle'])
	},
	mounted() {
		init(this)
		this.setHeaderStyle({headerStyle: 'light'})
	},
	beforeDestroy() {
		window.onscroll = null
	}
}
</script>

<style lang="scss">
@import '@/assets/css/ak';
</style>
